import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import * as moment from 'moment';

@Component({
    selector: 'app-external-test-request-details',
    templateUrl: './external-test-request-details.component.html',
    styleUrls: ['./external-test-request-details.component.scss'],
    standalone: false
})
export class ExternalTestRequestDetailsComponent implements OnInit, OnDestroy {
  @Input() data: any;
  time: string;
  mediaFiles = [];
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {
  }

  ngOnInit() {
    this.time = this.formatRequestTimeRange(this.data?.request_date, this.data?.request_interval);
    if (this.data?.pictures?.length) {
      this.mediaFiles = this.mapFileTypes(this.data.pictures);
    }
  }

  formatRequestTimeRange(requestDate: string, requestInterval: string): string {
    if (!requestDate || !requestInterval) {
      return '';
    }

    const start = moment(requestDate);
    const end = moment(requestDate).add(moment.duration(requestInterval));

    return `${start.format('hh:mm a')} - ${end.format('hh:mm a')}`;
  }

  deletePicture() {

  }

  private mapFileTypes(attachments: any[]): any[] {
    return JSON.parse(JSON.stringify(attachments)).map(item => {
      if (!item.fileType) {
        if (item.mime?.startsWith('image/')) {
          item.fileType = 'picture';
        } else if (item.mime?.startsWith('video/')) {
          item.fileType = 'video';
        } else if (item.mime?.startsWith('application/') || item.mime?.startsWith('text/')) {
          item.fileType = 'document';
        }
      }
      return item;
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
